// extracted by mini-css-extract-plugin
module.exports = {"title":"ZOVVP0te","content":"qjDAuRJQ","footer":"LUbKQnPK","modal":"WWr9Joba","okBtn":"BcC4b_JB","cancelBtn":"EL1ShMfX"};